import { useEffect, useState } from "react";

const PRUEF_MS = 5 * 60_000;

/** Der Build, den dieser Tab geladen hat — im Entwicklungsmodus gibt es keinen. */
function eigeneVersion(): string | null {
  const skript = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return skript?.src.match(/\/assets\/(index-[\w-]+\.js)/)?.[1] ?? null;
}

/**
 * Meldet, wenn auf dem Server eine neuere Oberfläche liegt. Eine offene App
 * oder installierte PWA läuft sonst nach einem Deploy tagelang mit altem Code
 * weiter — der Service Worker cacht nichts, aber neu geladen wird eben nur,
 * wenn jemand neu lädt.
 *
 * Geprüft wird beim Zurückkehren ins Fenster, wenn das Netz wiederkommt und
 * alle fünf Minuten. Neu geladen wird nie ungefragt: Ein halb getippter
 * Entwurf soll nicht verschwinden.
 */
export function useUpdateVerfuegbar(): boolean {
  const [neu, setNeu] = useState(false);

  useEffect(() => {
    const eigene = eigeneVersion();
    if (!eigene) return;
    let aus = false;
    const pruefen = async () => {
      if (aus || document.hidden) return;
      try {
        const r = await fetch("/api/version", { cache: "no-store", credentials: "same-origin" });
        if (!r.ok) return;
        const { web } = (await r.json()) as { web: string | null };
        if (web && web !== eigene) { setNeu(true); aus = true; }
      } catch { /* offline — beim nächsten Mal */ }
    };
    const t = window.setInterval(pruefen, PRUEF_MS);
    document.addEventListener("visibilitychange", pruefen);
    window.addEventListener("online", pruefen);
    window.addEventListener("focus", pruefen);
    return () => {
      aus = true;
      window.clearInterval(t);
      document.removeEventListener("visibilitychange", pruefen);
      window.removeEventListener("online", pruefen);
      window.removeEventListener("focus", pruefen);
    };
  }, []);

  return neu;
}
